export { default } from './InputWithOptions.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/InputWithOptions/index.js